module.exports = __webpack_public_path__ + "img/troll_small.8bd83497.png";